<template>
  <div class="card-list" v-if="loaded" :style="{ 'grid-template-columns': farmsByCompany.length ? null : '1fr' }">
    <template v-if="farmsByCompany.length">
      <farm-card-item
        v-for="item in farmsByCompany"
        :key="item.id"
        :item="item"
        @select="onSelect"
      />
    </template>
    <div class="table__empty full" v-else>
      <span v-if="searchQuery">
        {{ 'base.search' | translate }} "{{ searchQuery }}" {{ 'activities.not_found' | translate }}
      </span>
      <span v-else>{{ 'base.no_farms' | translate }}</span>
    </div>
  </div>
  <farm-card-item-skeleton v-else :count="6" />
</template>

<script>
import api from '@/api'

import FarmCardItem from './FarmCardItem'
import FarmCardItemSkeleton from './FarmCardItemSkeleton'

export default {
  name: 'FarmCardList',

  components: {
    FarmCardItem,
    FarmCardItemSkeleton
  },

  props: {
    searchQuery: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      loaded: false,
      farms: [],
      searchTimeout: null
    }
  },

  computed: {
    farmsByCompany () {
      return this.farms
    }
  },

  watch: {
    '$route.params.company_id' () {
      this.loadFarms()
    },

    '$route.params.client_id' () {
      this.loadFarms()
    },

    searchQuery () {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.loadFarms()
      }, 300)
    }
  },
  beforeDestroy () {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  },

  async mounted () {
    await this.loadFarms()
  },

  methods: {
    async loadFarms () {
      try {
        this.loaded = false

        const companyId = +this.$route.params.company_id
        const clientId = +this.$route.params.client_id
        const payload = companyId ? { company: companyId } : {}

        if (this.searchQuery && this.searchQuery.trim()) {
          payload.name = this.searchQuery.trim()
        }

        let data

        if (clientId) {
          const response = await api.dashboard.clients.getFarmsByIdV2(clientId, payload)
          data = response.data
        } else {
          const response = await api.farms.listV2(payload)
          data = response.data
        }

        this.farms = data
        this.loaded = true
      } catch (error) {
        console.error('Error loading farms:', error)
        this.loaded = true
        this.farms = []
      }
    },

    onSelect (item) {
      this.$emit('select', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.table__empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #666;
  background: #f5f5f5;
  border-radius: 1rem;
  
  &.full {
    grid-column: 1 / -1;
  }
}
</style>